import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuthStore } from "@/stores/auth/store";

/**
 * Public landing page for "/"
 */
const LandingPage: React.FC = () => {
   const {setUser, user} = useAuthStore();

   console.log("LandingPage user", user);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 to-slate-200 bg-contain" style={{ backgroundImage: "url('/images/ship.png')" }}>
      <Card className="w-full max-w-lg shadow-xl">
        <CardHeader>
          <CardTitle className="text-3xl font-bold text-center">
            Welcome to Pullentity
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center text-lg text-muted-foreground mb-6">
            Effortless site management, deployment, and collaboration.
          </p>
          <div className="flex flex-col gap-4">
            <Button asChild size="lg" className="w-full">
              <Link to="/login">Sign In</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full">
              <Link to="/register">Create Account</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
      <div className="mt-8 text-muted-foreground text-sm text-center">
        &copy; {new Date().getFullYear()} Pullentity. All rights reserved.
      </div>
    </div>
  );
};

export default LandingPage;
